import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import styles from './profile-empty-state.scss';

const ProfileEmptyState = ({ borderWidth, className, title, titleClassName, content, contentClassName, children }) => (
  <div className={classNames(styles.container, className)} style={{ borderWidth }}>
    <div className={styles.innerContainer}>
      <div className={classNames(styles.title, titleClassName)}>{title}</div>
      <div className={classNames(styles.content, contentClassName)}>{content}</div>
      {children && <div className={styles.cta}>{children}</div>}
    </div>
  </div>
);

ProfileEmptyState.propTypes = {
  borderWidth: PropTypes.number,
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  titleClassName: PropTypes.string,
  content: PropTypes.string.isRequired,
  contentClassName: PropTypes.string,
  children: PropTypes.node,
};

export default ProfileEmptyState;
